var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChackMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    rx: 11,
    fill: "#00F77C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51999 11.9469L15.8624 6.21341C16.1861 5.92073 16.6799 5.92407 16.9997 6.22111C17.339 6.5363 17.36 7.06639 17.0466 7.40738L10.2847 14.7652C9.72554 15.3736 8.7599 15.3549 8.22469 14.7254L5.59084 11.6273C5.28129 11.2632 5.3053 10.7219 5.64587 10.3866C5.97393 10.0637 6.49122 10.0358 6.85206 10.3217L8.92803 11.9662C9.10357 12.1052 9.35388 12.0971 9.51999 11.9469Z",
    fill: "#313139"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChackMark);
export default __webpack_public_path__ + "static/media/ChackMark.257f46084df86c3ea28713b61351f3e9.svg";
export { ForwardRef as ReactComponent };